import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'acs-simple-input-dialog',
  templateUrl: './simple-input-dialog.component.html',
  imports: [
    FontAwesomeModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule
  ],
  standalone: true
})
export class SimpleInputDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      confirmText: string;
      denyText: string;
      inputLabel: string;
      title: string;
      maxLength: string | number;
      value: string;
    },
    private dialogRef: MatDialogRef<SimpleInputDialogComponent>
  ) {}

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
